module.exports = __webpack_public_path__ + "a4824b8d6fa78ab7138db179c654f3cb.png";